import Button from 'components/Button'
import Text from 'components/Text'
import React from 'react'

export default function ModalOptionButton ({
  text,
  onClick
}) {
  return (
    <Button
      id={text}
      onClick={onClick}
      style={{
        width: '100%',
        height: 'unset',
        padding: '15px 10px',
        maxWidth: 'unset',
        textAlign: 'left',
        borderBottom: '1px solid #ebebeb'
      }}
    >
      <Text c='#000000'>{text}</Text>
    </Button>
  )
}
